<template>
  <v-container>
    <div v-if="collecteLoad">
      <h1 class="display-2">{{ collecte.titre }}</h1>
      <v-divider class="mt-2 mb-4"></v-divider>
      <p v-html="collecte.description"></p>
      <ObjectifProgress :amasse="collecte.amasse" :objectif="collecte.objectif" class="mb-6" />
      <template v-if="collecte.lienDetailsEvenement">
        <a :href="collecte.lienDetailsEvenement">
          <v-img :src="collecte.image"></v-img>
        </a>
      </template>
      <template v-else>
        <v-img :src="collecte.image"></v-img>
      </template>
      <h2 class="mt-6">{{ $t("collecte.listeobjectifs") }}</h2>
      <v-divider class="mb-4"></v-divider>
      <objectif-grid :listeObjectifs="collecte.listeObjectifs" :identifiantCollecte="identifiantCollecte" :lang="$route.params.lang"></objectif-grid>
      <router-view></router-view>
    </div>

    <div v-else>
      <v-skeleton-loader type="heading" class="mb-6"></v-skeleton-loader>
      <v-skeleton-loader type="text@4" class="mb-12"></v-skeleton-loader>
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import ObjectifGrid from "./ObjectifGrid"
import Objectif from "./Objectif"
import ObjectifProgress from "./ObjectifProgress"
import ChargementCollecte from "@/mixins/ChargementCollecte"

export default {
  mixins: [ChargementCollecte],
  name: "Collecte",
  components: { Objectif, ObjectifGrid, ObjectifProgress },
  mounted() {
    if (!this.collecte || this.$route.query.forceRefresh) {
      this.chargerCollecteEnCours()
    }
  }
}
</script>

<style scoped>
</style>